export const CREATE_CHAT_REQUEST = "CREATE_CHAT_REQUEST"
export const CREATE_CHAT_SUCCESS = "CREATE_CHAT_SUCCESS"
export const CREATE_CHAT_FAIL = "CREATE_CHAT_FAIL"
export const CHAT_RESET = "CHAT_RESET"

export const GET_CHAT_REQUEST = "GET_CHAT_REQUEST"
export const GET_CHAT_SUCCESS = "GET_CHAT_SUCCESS"
export const GET_CHAT_FAIL = "GET_CHAT_FAIL"

export const GET_CHATSBYID_REQUEST = "GET_CHATSBYID_REQUEST"
export const GET_CHATSBYID_SUCCESS = "GET_CHATSBYID_SUCCESS"
export const GET_CHATSBYID_FAIL = "GET_CHATSBYID_FAIL"

export const UPDATE_CHATNAME_REQUEST = "UPDATE_CHATNAME_REQUEST"
export const UPDATE_CHATNAME_SUCCESS = "UPDATE_CHATNAME_SUCCESS"
export const UPDATE_CHATNAME_FAIL = "UPDATE_CHATNAME_FAIL"

export const CREATE_MESSAGE_REQUEST = "CREATE_MESSAGE_REQUEST"
export const CREATE_MESSAGE_SUCCESS = "CREATE_MESSAGE_SUCCESS"
export const CREATE_MESSAGE_FAIL = "CREATE_MESSAGE_FAIL"

export const GET_MESSAGE_REQUEST = "GET_MESSAGE_REQUEST"
export const GET_MESSAGE_SUCCESS = "GET_MESSAGE_SUCCESS"
export const GET_MESSAGE_FAIL = "GET_MESSAGE_FAIL"

export const GET_UNREAD_MESSAGE_REQUEST = "GET_UNREAD_MESSAGE_REQUEST"
export const GET_UNREAD_MESSAGE_SUCCESS = "GET_UNREAD_MESSAGE_SUCCESS"
export const GET_UNREAD_MESSAGE_FAIL = "GET_UNREAD_MESSAGE_FAIL"